<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
				<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<router-link data-toggle="tooltip" title="Добави" class="btn btn-success" to="/discussion/new"><i class="fa fa-plus"></i></router-link>
					<!-- router-link data-toggle="tooltip" title="Добави" class="btn btn-success" to=""><i class="fa fa-plus"></i></router-link-->
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">

		<div class="card">
			<div class="card-block">
				<div class="row">
					<div class="col-sm-6">
						<div class="md-form form-sm">
							<i class="fa fa-search prefix"></i>
							<input type="text" v-model="filter.search" @keyup.enter="fetchData()" class="form-control" placeholder="Търсене по тема">
						</div>
					</div>
					<div class="col-sm-6">
						<f-select v-model="filter.section" :values="sectionValues" :hide-name="true" @input="fetchData()" allow-none cplaceholder="Търсене по секция"></f-select>
					</div>
				</div>
				<table class="table table-no-bordered table-hover table-responsive" cellspacing="0" width="100%" style="width: 100%;">
					<thead>
						<tr>
							<th class="sorting_asc" style="width: 143px;">Тема</th>
							<th class="sorting" style="width: 215px;">Секция</th>
							<!-- <th class="sorting" style="width: 200px;">Участници</th> -->
							<th class="sorting" style="width: 20px;">Отговори</th>
							<th class="sorting" style="width: 50px;">Последно</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in records.items" role="row" @keydown.enter="$router.push('/discussion/' + item.id)" @click="((item.section.paid || 0) > ($user.familyUser.family.paid || 0)) || $router.push('/discussion/' + item.id)" :tabindex="(item.section.paid || 0) > ($user.familyUser.family.paid || 0) ? -1 : 0">
							<td>
								<span v-if="(item.section.paid || 0) > ($user.familyUser.family.paid || 0)" class="text-muted">{{ item.title }}</span>
								<span v-else>{{ item.title }}</span>
							</td>
							<td>
								<span class="cat-badge" :style="'background-color:' + (item.section.color || 'black')"></span>
								<i v-if="(item.section.paid || 0) > ($user.familyUser.family.paid || 0)" class="fa fa-lock"></i>
								{{ item.section.name }}
							</td>
							<!-- <td>
								<a v-for="itemNum in item.participants" href="/family"><c-avatar image="/network/static/img/default.jpg" title="name 1"></c-avatar></a>
							</td> -->
							<td>{{ item.postCount }}</td>
							<td class="text-left" :title="item.updatedAt | prettyDateTime">{{ item.updatedAt | fromNowDateTime }}</td>
						</tr>
					</tbody>
				</table>
				<div class="row">
					<div class="col-sm-12">
						<f-pager :total="records.total" :clickhandler="pageClick"></f-pager>
					</div>
				</div>
			</div>
		</div><!--	end card	-->

	</div>
</div>
</template>

<script>
var cache = require('./section-cache');

module.exports = {
	data: function () {
		return {
			dataReady: false,
			cache: cache.data,
			page: 0,
			records: {},
			filter: {
				search: '',
				section: ''
			}
		};
	},
	created: function () {
		this.fetchData();
		cache.prepare(this);
	},
	watch: {
		$route: 'fetchData'
	},
	computed: {
		sectionValues () {
			if (!this.cache.dataReady) return {};
			let result = {};
			for (let i in this.cache.sections) {
				result[i] = {text: this.cache.sections[i].name, color: this.cache.sections[i].color};
			}
			return result;
		}
	},
	methods: {
		fetchData: function () {
			var query = []; // From https://stackoverflow.com/a/1714899
			for (var key in this.filter) {
				if (this.filter[key]) {
					query.push(encodeURIComponent(key) + '=' + encodeURIComponent(this.filter[key]));
				}
			}

			query.push('page=' + this.page);
			query.push('limit=' + this.$config.rpp);

			this.$http.get('backend://topic?' + query.join('&')).then((result) => {
				this.records = result.body;
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		pageClick: function (page) {
			this.page = page;
			this.fetchData();
		}
	}
};

</script>
<style>

</style>



// WEBPACK FOOTER //
// Topics.vue?47056341